(function (getours) {

    // Global namespaces defined
    getours.Models = {};
    getours.Services = {};
    getours.Components = {};

}(window.getours = window.getours || {}));